<template>
	<page>
		<module>
			<view-list work-type="43" ref="view" selector :view-config="auth('b_quality_output_after_viewmanage')">
				<template #search>
					<m-search ref="search">
						<m-search-item label="工单编号">
							<c-input name="work_code"></c-input>
						</m-search-item>
						<m-search-item label="生产人员">
							<c-select name="output_user_ids" async multiple @search="searchOutputUser" ></c-select>
						</m-search-item>
						<m-search-item label="工序编号">
							<c-input name="process_code"></c-input>
						</m-search-item>
						<m-search-item label="工序名称">
							<c-input name="process_name"></c-input>
						</m-search-item>
						<m-search-item label="产品编号">
							<c-input name="product_code"></c-input>
						</m-search-item>
						<m-search-item label="产品名称">
							<c-input name="product_name"></c-input>
						</m-search-item>
						<m-search-item label="规格名称">
							<c-input name="product_spec"></c-input>
						</m-search-item>
						<m-search-item label="检验方式">
							<c-select name="test_modes" :options="testModeQualityDic" multiple ></c-select>
						</m-search-item>
						<m-search-item label="处理方式">
							<c-select name="after_types" :options="afterTypeDic" multiple ></c-select>
						</m-search-item>
						<m-search-item label="处理状态">
							<c-select name="after_states" :options="afterStateDic" multiple ></c-select>
						</m-search-item>
						<m-search-item label="质检时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button v-if="auth('b_quality_output_after_export')" v-lock="lock('b_quality_output_after_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_quality_output_after_export')" v-lock="lock('b_quality_output_after_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
				</template>

				<template #batchOperate="{data}">
					<c-button v-if="auth('b_quality_output_after_export')" v-lock="lock('b_quality_output_after_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_quality_output_after_export')" v-lock="lock('b_quality_output_after_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
					<c-button v-if="auth('b_quality_output_after_print')" v-lock="lock('b_quality_output_after_print')" prepend-icon="tf-print" @click="$refs.view.batchExportByTemplate()">打印</c-button>
					<c-button v-if="auth('b_quality_output_after_output')" v-lock="lock('b_quality_output_after_output')" color="main" prepend-icon="tf-deliver" @click="createOutput()">生成报工</c-button>
				</template>

				<!--处理方式-->
				<template #after_type="{data}">
					<c-state dict="afterTypeDic" :value="data.after_type"></c-state>
				</template>

				<!--处理状态-->
				<template #after_state="{data}">
					<c-state dict="afterStateDic" :value="data.after_state"></c-state>
					<span v-if="data.after_state == 2">(生成报工)</span>
				</template>

				<!--检验方式-->
				<template #test_mode="{data}">
					<c-state dict="testModeDic" :value="data.test_mode"></c-state>
				</template>
				
				<!--质检人-->
				<template #test_user_realname="{data}">
					<span v-if="data.test_state == 3">{{data.test_user_realname}}</span>
					<span v-else>-</span>
				</template>
				
				<!--工单编号-->
				<template v-if="auth('m_work')" #work_code="{data}">
					<c-link @click="globalDialog('workDetail', {props: {id: data.work_id}})">{{data.work_code}}</c-link>
				</template>
				
				<!--工序编号-->
				<template v-if="auth('m_task')" #process_code="{data}">
					<c-link @click="globalDialog('taskDetail', {props: {id: data.task_id}})">{{data.process_code}}</c-link>
				</template>
				
				<!--工序名称-->
				<template v-if="auth('m_task')" #process_name="{data}">
					<c-link @click="globalDialog('taskDetail', {props: {id: data.task_id}})">{{data.process_name}}</c-link>
				</template>
				
				<c-table-column
					type="button"
					label="操作"
					width="140"
					button-limit="2"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_quality_output_after_output')" v-lock="lock('b_quality_output_after_output')" :disabled="!(data.after_state == 1)" icon="tf-deliver" @click="createOutput(data.id)">生成报工</c-table-button>
						<c-table-button v-if="auth('b_quality_output_after_print')" v-lock="lock('b_quality_output_after_print')" icon="tf-print" @click="$refs.view.exportByTemplate(data.id)">打印</c-table-button>
					</template>
				</c-table-column>
			</view-list>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	
	export default {
		components: {
			
		},

		data() {
			return {
			}
		},
		
		computed: {
			// 获取dictName选项数据
			...mapState(['userInfo', 'outputTypeDic', 'testModeQualityDic', 'afterTypeDic', 'afterStateDic'])
		},
		
		mounted() {
		    this.$bus.$on('output.after.list.update', data => {
		        // 刷新列表
		        this.$refs.view.update();
		    });
		},
		
		beforeDestroy() {
			this.$bus.$off('output.after.list.update');
		},
		
		methods: {
			/**生成报工记录*/
			createOutput(id){
				var ids = [];
				if(id){
					ids.push(id);
				}else{
					this.$refs.view.$refs.list.getData('selected').forEach(item => {
						ids.push(item.id);
					});
				}
				this.$confirm({
					message:'生成报工后将在原工单对应工序任务新增一条【返工】类型的报工，状态为【待提交】，是否确定操作？已处理系统将自动跳过',  // 提示内容,
					buttonName: '确定生成',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url:'/test/defects/createOutput',
							data: {
								ids: ids
							},
							loading: true,
							success:data => {
								this.$message({
									message:'生成报工成功',  // 提示内容,
									type: 'success'
								});
								//刷新
								this.$refs.view.update();
							}
						})
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},
			
			/*******搜索【员工】下拉框信息*****************/
			searchOutputUser(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'SYSUSER',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},
		}
	}
</script>

<style lang="stylus" scoped>
</style>